import * as css from "./style.css";

export function Multiplier(props: { count: number; fontSize?: 14 | 20 }) {
  return (
    <sup className={css.counter({ fontSize: props.fontSize })}>
      x{props.count}
    </sup>
  );
}
